var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleSource(undefined, 1)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("addAdPlacement")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "margin-top",
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ID", label: _vm.$t("idLabel"), "min-width": "60" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "game_reveal",
              label: _vm.$t("gameName"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "platform_reveal",
              label: _vm.$t("platformName"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channel_reveal",
              label: _vm.$t("channelName"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pkg_reveal",
              label: _vm.$t("pkgName"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "origin",
              label: _vm.$t("adMark"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_channel_reveal",
              label: _vm.$t("adChannel"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_placement_reveal",
              label: _vm.$t("adPlacement"),
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "conf", label: _vm.$t("configuration") }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "160",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleSource(scope.row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("modify")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete(scope.row.ID)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("adConfigRt", {
        ref: "adConfigRt",
        on: { refreshDataList: _vm.getData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }